export const CREATE_ORG_CHART = "CREATE_ORG_CHART";
export const FETCH_ORG_CHARTS = "FETCH_ORG_CHARTS";
export const FETCH_ORG_CHART = "FETCH_ORG_CHART";
export const EDIT_ORG_CHART = "EDIT_ORG_CHART";
export const DELETE_ORG_CHART = "DELETE_ORG_CHART";
